import { CountryCode } from '@constants'

/**
 * TODO: SD-10063 優化 address_info 格式，將 state 拆出 postcode、state、city
 * 台灣的 combinedString 格式如下
 * ex: '104,台北市,大安區'
 * 第一個是 postcode，第二個是 state，第三個是 city
 *
 * 海外的 combinedString 和台灣不同
 * 1. 港澳
 * ex: "北區,打鼓嶺"
 * 第一個是 state，第二個是 city
 *
 * 2. 新加坡
 * 沒有 availableStates 是空 array
 *
 * 3. 馬來西亞
 * ex: Terengganu,Sungai Tong
 * 第一個是 state，第二個是 city
 */
export interface ParsedState {
  state: string
  city: string
  postcode: string
}

const splitCombinedState = (combinedString: string) => combinedString.includes(',') ? combinedString.split(',') : combinedString.split(' ')

/**
 * @deprecated
 * 拆解 combinedString 為 state、city、postcode
 * appliedAddressbook 只有在 mnp us 套用常用收件地址會用到
 */
export const parseState = (combinedString = '', billingCountry: CountryCode, appliedAddressbook = false): ParsedState => {
  if (billingCountry === CountryCode.TW) {
    const [postcode, state, city] = splitCombinedState(combinedString)
    return { postcode: postcode || '', state: state || '', city: city || '' }
  }
  if (billingCountry === CountryCode.US) {
    /** mnp us 套用常用收件因為後端沒給 postcode，因此拆出來的欄位會是錯誤的 */
    if (appliedAddressbook) {
      const [state, city] = splitCombinedState(combinedString)
      return { postcode: '', state: state || '', city: city || '' }
    }
    else {
      const [postcode, state, city] = splitCombinedState(combinedString)
      return { postcode: postcode || '', state: state || '', city: city || '' }
    }
  }
  const [state, city] = splitCombinedState(combinedString)
  return { postcode: '', state: state || '', city: city || '' }
}
